import React from 'react';
import {TaxReturnBasicFieldsConfig} from '../CreateReturn.constants';
import {useFormData} from 'src/DesignSystem/Form/useFormData';
import {Form} from 'src/DesignSystem/Form/Form';
interface BasicTaxReturnFieldsProps {
  fields: ReturnType<typeof useFormData>['fields'];
  validationDisabled: boolean;
}

const BasicTaxReturnFields = ({
  fields,
  validationDisabled,
}: BasicTaxReturnFieldsProps) => {
  const mandatoryFields = TaxReturnBasicFieldsConfig.map(
    (field) => field.path,
  );

  return fields
    .filter((field) => mandatoryFields.includes(field.path))
    .map((field) => (
      <div>
        <Form {...field} disableValidation={validationDisabled} />
      </div>
    ));
};

export default BasicTaxReturnFields;
